import { ReactComponent as IconBlock } from "assets/images/icons/block.svg";
import { ReactComponent as IconTrash } from "assets/images/icons/trashfull.svg";
import MessageCreate from "pages/MessageBox/MessageCreate";
import Button from "components/ui/Button/Button";
import "pages/MessageBox/MessageControls.scss";
import ButtonBlock from "pages/Profile/ButtonBlock";
import ConversationDelete from "pages/MessageBox/ConversationDelete";
import { useDialog } from "context/DialogContext";
import { useMessageBox } from "pages/MessageBox/MessageBoxContext";

function MessageControls({ profile, messages }) {
  const { showDialog } = useDialog();
  const { refreshConversations } = useMessageBox();

  return (
    <div className={ 'message-controls' }>
      <Button variant={ 'secondary' }
              className={ 'button--small margin-right-extra-small' }
              onClick={ () => showDialog(<MessageCreate receiver={ profile }
                                                        onCompleted={ refreshConversations }/>) }>
        Nieuw bericht
      </Button>
      <div className={ 'message-controls__buttons' }>
        <Button variant={ 'ghost' } className={ 'button--small' }
                onClick={ () => showDialog(<ConversationDelete messageCount={ messages.length }
                                                               name={ profile.title.value }
                                                               senderId={ profile.uid }
                                                               onCompleted={ refreshConversations } />) }>
          <IconTrash/>
          Gesprek verwijderen
        </Button>

        <ButtonBlock userId={ profile.uid }>
          <IconBlock/>
          Lid blokkeren
        </ButtonBlock>
      </div>
    </div>
  );
}

export default MessageControls;
